<template>
  <div class="credit-card">
    <!-- 支付记录/发票记录 -->
    <div class="tabs-box">
      <xl-tabs class="info-tabs" v-model="activeTab" :tabLists="tabList" @tab-click="onTabClick" @tab-change="handleChange">
        <!-- 支付记录 -->
        <template #payment>
          <paymentRecords ref="paymentRef" :cardNo="cardNo" :platform="platform"></paymentRecords>
        </template>
        <!-- 发票记录 -->
        <!-- <template #invoice>
          <invoiceRecords></invoiceRecords>
        </template> -->
        <!-- 积分详情 -->
        <template #point>
          <point-records @pointDetail="onPointDetail" :platform="platform"></point-records>
        </template>
      </xl-tabs>
    </div>
  </div>
  <addCardDialog ref="addCardRef" @getDefaultCard="getDefaultCard"></addCardDialog>
  <addContactDialog ref="addContactRef" @getShowContact="getShowContact"></addContactDialog>
</template>

<script setup>
import { XlIcon, XlTabs } from "@shining3d/ui-components";
import { ref, onMounted, computed, watch, nextTick, defineProps } from "vue";
import addCardDialog from "./components/addCardDialog.vue";
import addContactDialog from "./components/addContactDialog.vue";
import paymentRecords from "./components/paymentRecords.vue";
import invoiceRecords from "./components/invoiceRecords.vue";
import creditCard from "./components/creditCard.vue";
import contactCard from "./components/contactCard.vue";
import PointRecords from "./components/pointRecords.vue";
import creditCardApi from "../api/creditCard";
import { XlPlus, Warning } from "@shining3d/icons-vue";
import router from "@/router";
import _get from 'lodash/get';
import { useLang } from '@shining3d/common-module/utils/lang.js';
const { $t } = useLang( '@shining3d/xl-design-order' );
const route = router.currentRoute.value;
import { useStore } from "vuex";

const props = defineProps({
  platform: {
    type: String,
    default: 'dental'
  }
})

const $store = useStore();
// 付款方式-更多
const openMoreCard = () => {
  router.push({ path: "/u/creditCard/creditCardList" });
};
// 账单联系人-更多
const openMoreContact = () => {
  router.push({ path: "/u/creditCard/billContactList" });
};
// 新增信用卡
const addCardRef = ref();
const addCard = () => {
  addCardRef.value.show();
};
// 默认信用卡
const defaultCard = ref();
// 账单联系人
const showContact = ref();
// 新增账单联系人
const addContactRef = ref();
const addContact = () => {
  addContactRef.value.show();
};
const activeTab = ref('payment');
const tabList = [
  { label: $t('design.creditCard.paymentRecord') || '支付记录', name: "payment", lazy: true },
  { label: $t('design.creditCard.pointRecord') || '积分详情', name: "point", lazy: true },
  // { label: $t('design.creditCard.invoiceRecord') || '发票记录', name: "invoice", lazy: true },
];
// 机构id
const institutionId = _get( $store, 'state.factorySelect.id', '' );
// 获取默认信用卡
const getDefaultCard = () => {
  creditCardApi.getPayCard({businessID: institutionId, platform: window.app?.entryName || 'dental'}).then((res) => {
    if( res && res.status === 'success' ){
      defaultCard.value = res.result?.find((item) => item.isDefault === 'y' );
      // if( defaultCard.value ){
      //   $setLocalStorage('hasDefaultCard', true);
      // }
    }
  });
}
// 获取第一个绑定的账单联系人
const getShowContact = () => {
  creditCardApi.getBillContact({businessID: institutionId, platform: window.app?.entryName || 'dental'}).then((res) => {
    if( res && res.status === 'success' ){
      showContact.value = res.result?.length ? res.result[0] : '';
    }
  });
}

const cardNo = ref('');
const paymentRef = ref();
// 从积分记录跳转过来，筛选积分记录的列表
const onPointDetail = ( id ) => {
  handleChange('payment');
  // if (paymentRef.value) {
  //   paymentRef.value.searchPoint( id );
  // } else {
    cardNo.value = id;
  // }
  activeTab.value = 'payment';
};

const handleChange = ( val ) => {
  const query = _get( router, 'currentRoute.value.query', {});
  const params = _get( router, 'currentRoute.value.params', {});
	router.replace({ query: { ...query, paymentType: val }, params: { ...params } });
};

const changeActiveName = () => {
  const type = _get( router, 'currentRoute.value.query.paymentType', '' );
	activeTab.value = tabList.some(( val ) => val.name === type ) ? type : 'payment';
};

const onTabClick = ( name ) => {
  if ( activeTab.value === 'payment' ) {
    cardNo.value = '';
    // paymentRef.value.searchPoint('');
  }
};

watch(() => router, () => {
  const routeName = _get( router, 'currentRoute.value.name');
  const target = _get( router, 'currentRoute.value.params.target', '');
  if ( (routeName === "institutionSetting" && target === 'payment') || ( props.platform === 'designerService' && routeName === "Organization")) {
    changeActiveName();
    if ( activeTab.value === 'payment' ) {
      if ( paymentRef.value ) {
        paymentRef.value.searchPoint( cardNo.value );
      }
    }
  } else {
    cardNo.value = '';
  }
}, { immediate: true, deep: true });

// 获取默认信用卡
// getDefaultCard();
// 获取第一个绑定的账单联系人
// getShowContact();
onMounted(() => {
  if( route?.params?.showAddCard ){
    addCard();
  }
});
</script>

<style lang="scss" scoped>
.credit-card {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 0px 24px 0 24px;
  box-sizing: border-box;
  background: #ffffff;
  font-family: "Alibaba PuHuiTi 2.0";
  overflow-x: auto;
  .card-container{
    display: flex;
    width: max-content;
  }
  .add-card {
    display: flex;
    height: fit-content;
    .payment {
      margin-right: 16px;
    }
  }
  .add-contact {
    height: fit-content;
  }
  .card-box {
    width: 460px;
    height: 156px;
    padding: 16px;
    border-radius: 10px;
    box-sizing: border-box;
  }
  .show-card {
    border: 1px solid #eff1f7;
    box-shadow: 0px 2px 10px 0px #111b330d;
  }
  .text-color {
    color: #737e99;
  }
  .add-box {
    background: #f7f8fa;
    border: 2px dashed #e0e4ea;
    &:hover {
      border: 2px dashed #5587ff !important;
      background: #edf3ff !important;
      .plus-icon {
        color: #5587ff !important;
      }
    }
    .plus-icon {
      width: 66px;
      height: 66px;
      color: #ced2db;
      cursor: pointer;
    }
  }
  .bind-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .bind-card {
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      margin-top: 12px;
      color: #a5acbe;
      .no-bind {
        margin-right: 12px;
      }
      .bind-text {
        color: #5587ff !important;
        cursor: pointer;
      }
    }
  }
  .text-box {
    font-size: 14px;
    font-weight: 500;
    line-height: 22px;
  }
  .payment-text {
    color: #2c364e;
  }
  .payment-method {
    display: flex;
    justify-content: space-between;
    margin-bottom: 24px;
    .add-text {
      display: flex;
      align-items: center;
      color: #5587ff;
      &:hover {
        cursor: pointer;
      }
      .add-more {
        margin-left: 4px;
      }
    }
  }
  .tabs-box{
    // flex: 1;
    // min-width: max-content;
    // margin-top: 20px;
    height: 100%;
    flex-flow: column nowrap;
    overflow: hidden;
    :deep(.el-tabs__nav-wrap){
      padding-left: 0 !important;
    }
    :deep(.el-tabs__item){
      // padding: 0 24px;
    }
    :deep(.el-tabs__content){
      flex: 1;
      padding: 0 !important;
      overflow: auto;
    }
    :deep(.el-tabs){
      display: flex;
      flex-direction: column;
      height: 100%;
    }
    :deep(.el-tab-pane) {
	    height: 100%;
      display: flex;
      flex-flow: column nowrap;
    }
  }
}
</style>
